import { FC, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box } from '@altermaind/web/ui';
import { TutorialDialog } from '@/_shared/components/TutorialDialog';
// import { useDialog } from '@/_shared/hooks/useDialog';
import { CardPlayground } from './CardPlayground';
import { CardsPlayground } from './CardsPlayground';
import { IntroPlayground } from './IntroPlayground';
import { Programs } from './Programs';

export const LandingPlayground: FC = () => {
  const t = useTranslations('aiPlayground.learning.tutorial.slides');
  // const { openDialog: openDialogSoftSkillsTutorial } = useDialog('softSkillsTutorial');

  const slides = [
    {
      title: t('slide1.title'),
      description: t('slide1.description'),
      assetName: 'tutorialSoftSkillsAiPlaygroundSlide1',
    },
    {
      title: t('slide2.title'),
      description: t('slide2.description'),
      assetName: 'tutorialSoftSkillsAiPlaygroundSlide2',
    },
  ];

  useEffect(() => {
    /*
     * TODO: Uncomment the lines below and lines 5,13 when the new Soft Skills UI (v2) is released.
     * Removing the comments will enable the Soft Skills tutorial dialog.
     * The image assets already correspond to the Soft Skills UI v2.
     */
    // const hasSeenSoftSkillsTutorial = localStorage.getItem('hasSeenSoftSkillsTutorial');
    // if (hasSeenSoftSkillsTutorial !== 'true') {
    //   openDialogSoftSkillsTutorial();
    //   localStorage.setItem('hasSeenSoftSkillsTutorial', 'true');
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box mb='xxl'>
      <IntroPlayground />
      <CardsPlayground
        elementToView={{
          desktopLarge: 4.5,
          desktop: 3.5,
          tablet: 2.5,
          mobile: 1,
        }}
      />
      <Programs />
      <CardPlayground />
      <TutorialDialog
        translationsKey='aiPlayground.learning.tutorial'
        dialogKey='softSkillsTutorial'
        slides={slides}
      />
    </Box>
  );
};
